import { useContext } from "react";
import styled from "styled-components";
import { confirmAlert } from "react-confirm-alert";
import AuthContext from "../context/auth/AuthContext";
import MenuContext from "../context/menus/MenuContext";
import MensajeNoHayDatos from "./MensajeNoHayDatos";
import Menu from "./Menu";

function MenuDiario({ menus }) {
  const { usuario } = useContext(AuthContext);
  const { hacerPedido, cancelarPedido } = useContext(MenuContext);

  const reservar = (menu) => {
    const data = {
      usuario,
      menu,
    };
    confirmAlert({
      title: "¿Deséa reservar este delicioso plato?",
      message: "Que disfrute sus alimentos!",
      buttons: [
        {
          label: "Si",
          onClick: () => {
            hacerPedido(data);
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  };

  const cancelar = (menu) => {
    const data = {
      usuario,
      menu,
    };
    confirmAlert({
      title: "¿Deséa cancelar la reserva anterior?",
      message: "Lo sentimos mucho, esperamos haga otro pedido.",
      buttons: [
        {
          label: "Si",
          onClick: () => {
            cancelarPedido(data);
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  };

  return (
    <Container>
      {menus.length === 0 ? (
        <MensajeNoHayDatos mensaje="No se han creado menús para clientes" />
      ) : (
        <div>
          <Titulo>Nuestro Menú</Titulo>
          <Grid>
            {menus.map((menu) => (
              <Menu
                key={menu.id}
                menu={menu}
                usuario={usuario}
                cancelar={cancelar}
                reservar={reservar}
              />
            ))}
          </Grid>
        </div>
      )}
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  padding: 2rem;
  margin-bottom: 10px;
  p {
    font-weight: 300;
  }
`;

const Titulo = styled.h2`
  font-family: "Caveat", cursive;
  font-size: 2rem;
  margin-top: 0;
  margin-bottom: 20px;
  text-align: center;
`;

const Grid = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;

  @media (min-width: 500px) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem;
  }

  @media (min-width: 800px) {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;
  }

  @media (min-width: 1024px) {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 2rem;
  }
`;

export default MenuDiario;
